import { invalidateMinicart } from "~/app/store/bffApi";
import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { resolveActiveCartResourceId } from "../utils/cartResourceIdentity";

export async function apiDeleteProduct(productCode: string): Promise<void> {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot delete product without an Active Cart");
  }

  const response = await occFetch(
    occBaseSiteUrl(
      `${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/products/${encodeURIComponent(productCode)}`,
    ),
    {
      method: "DELETE",
    },
  );
  if (!response.ok) {
    throw new Error("Error when deleting product");
  }
  invalidateMinicart();
}
